import type { TableColumn } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { makeIsColumnVisible } from 'components/Table/helpers/makeIsColumnVisible';
import type { TableMergedState } from 'components/Table/model/TableModel';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import { selectOrderedColumns } from './selectOrderedColumns';

export const selectVisibleColumns: (s: TableMergedState) => TableColumn<any>[] =
  createScopedSelector(() =>
    createSelector(
      selectOrderedColumns,
      prop('settings', 'columnVisibility'),
      (orderedColumns, columnVisibility) =>
        orderedColumns.filter(makeIsColumnVisible(columnVisibility)),
    ),
  );
